import {authHeader} from "@/services/auth-header";
import router, {developer} from "@/main";
import {Axios} from "@/services/repositories";

export const userService = {
    login,
    logout,
    getUser,
    isDeleteAllowed
};

function login(login, password) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ login, password })
    };

    return fetch(`/api/auth/login`, requestOptions)
        .then(handleAuthResponse)
        .then(async function(response) {
            // login successful if there's a jwt token in the response
            if (response.token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes

                localStorage.setItem('jwt', response.token);
                localStorage.setItem('jwt_life_time', response.expired);
                localStorage.setItem('user', JSON.stringify({name: response.username, id: response.id, role: response.role}));
                localStorage.setItem('delete', response.role === "ROLE_ADMIN" ? "1" : "0");

                Axios.defaults.headers = await authHeader();
                await router.push('/');
            }
        });
}

function logout() {
    // remove user from local storage to log user out
    //let beaver =  authHeader().substr(4);
    localStorage.setItem('user', '');
    localStorage.setItem('jwt', '');
    localStorage.setItem('jwt_life_time', '');
    router.push('/login');
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ beaver: beaver})
    };
    fetch(`/api/auth/out`, requestOptions)
        .then(router.push('/'));
}

function getUser() {
    return JSON.parse(localStorage.getItem('user') ? localStorage.getItem('user') : '{}');
}

function isDeleteAllowed() {
    return localStorage.getItem('delete') === '1';
}

export function handleAuthResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}

export function handleResponse(response) {
    return response.data;
}